<template>
<div   :style="{
    fontSize: $vuetify.breakpoint.xs ? '12px' : '16px'
  }">
   <!-- SE QUITO la propiedad app PARA QUITAR EL MARGEN , Y SE AGREGO FIXED PARA DEJAR FIJO, Y SE AGREGO EL MARGEN EN HomeTiendaAll.vue -->
<template>
  <CerrarSesionDialog ref="componenteHijo"></CerrarSesionDialog>
<OpenLinksTecDialog ref="componenteHijoOpenLinksTec"></OpenLinksTecDialog>
  <v-app-bar

      fixed
      dark
      height="200"
      
      >
      <template v-slot:img="{ props }" >
        <v-img
          v-bind="props"
          gradient=""
          class="hidden-sm-and-down"
        ></v-img>
      </template>
        <v-toolbar-title class="hidden-sm-and-down">TecZoa Store
        </v-toolbar-title>
        <v-spacer></v-spacer>
 <template v-slot:extension>
 <v-row no-gutters>
   <v-col cols="12" class="hidden-sm-and-down">
 <v-tabs
          align-with-title
          background-color="transparent"
        >

       <v-tab class="mr-3 google-font hidden-sm-and-down"
        style="text-transform: capitalize;pading" 
        @click="openStore()"
        >
        HOME
        </v-tab> 
 <v-tab
        v-for="(link, i) in linksStore"
        :key="i"
        :to="link.to"
        class="mr-3 google-font hidden-sm-and-down"
        
        @click="onClick($event, link)"
        data-cy="menu"
      >
        {{ link.text }}
        </v-tab>
       <v-tab class="mr-3 google-font hidden-sm-and-down"
        @click="openLinksTec()"
         >
        Links Tec
        </v-tab>
 </v-tabs>
 </v-col>
  </v-row>
  <v-row no-gutters   class="mt-0 pb-16 mb-15">
  <v-col cols="10" class="pb-0">
    <div class="font-weight-bold mb-1 ml-1">Productos y Servicios</div>
   <div 
   class="divider mb-2"></div>
  </v-col>
 <v-col cols="10" sm="10" md="10" lg="10" class="mt-0 mb-0">
  <v-radio-group
         :value="vendedorSeleccionadoLocal"
  @change="onChange"
        row
        dense
      >
        <v-radio
          v-for="(ven, i) in vendedores"
          :key="i"
          :label="ven.nombre"
          :value="ven.identificador"
        />
      </v-radio-group>
    </v-col>

       <!-- Título + línea -->
  <v-col cols="10" class="pb-0">
    <div class="font-weight-bold mb-1 ml-1">Categorias</div>
    <v-divider class="mb-2"></v-divider>
  </v-col>

 <v-col cols="10" sm="10" md="10" lg="10" class="mt-0 mb-0">
      <v-radio-group
         v-model="categoriaLocal"
  @change="$emit('update-categoria', categoriaLocal)"
        row
        dense
      >
        <v-radio
          v-for="(cat, i) in categorias"
          :key="i"
          :label="cat.descripcion"
          :value="cat.descripcion"
        />
      </v-radio-group>
</v-col>

    <v-col cols="10" class="pb-16">
<v-text-field
        :value="buscador"
        @input="updateBuscador"
        placeholder="Ejemplo: Tablero de Ajedrez, Arduino, Crema, Loción"
        outlined
        dense
        hide-details
      >
        <template v-slot:label>
          <v-icon >mdi-magnify</v-icon>
          Busqueda por descripción de productos
        </template>
</v-text-field>
 </v-col>
</v-row>
<v-row no-gutters  class="justify-end">
<!-- Otros iconos 
    <v-col cols="2" class="hidden-sm-and-down">
      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-col>
-->
<v-app-bar-nav-icon class="hidden-md-and-up"
      @click="toggleDrawer"></v-app-bar-nav-icon>
    </v-row>
<template>
  </template>
</template>
 </v-app-bar>
</template>
</div>
  </template>
<script>


import CoreView from '@/components/common/View'
import ChapterDetails from '@/assets/data/chapterDetails.json'

import categoriaService from "@/services/tienda/categoriaService.js";

import vendedorService from "@/services/tienda/vendedorService.js";

import router from "@/router/index";


import loginService from "@/services/loginService.js";


import CerrarSesionDialog from "@/components/usuario/CerrarSesionDialog.vue"


import OpenLinksTecDialog from "@/components/tienda/menu/OpenLinksTecDialog.vue"


  import { 
    mapGetters,
    mapMutations
  } from 'vuex'
  export default {
    name:'Menu',
    props: {
    buscador: {
      type: String,
      default: ""
    },
    categoriaSeleccionada: {
    type: String,
    default: "todos"
  }
  ,
    vendedorSeleccionado: {
    type: [String, Number],
    default: 'all'
  }
  },
   data() {
      return {

        vendedorSeleccionadoLocal:'all',
        categoriaLocal: this.categoriaSeleccionada,

principal: {

      id: '',
      nombre: '',
      apellido: '',
      descripcion: '',
      linkPhoto: '',
      color: '',
      observacion: '',
      linkVideo: '',
    },
        vendedores:[],
        vendedor:'1',
       // identificadorConsulta:'magzoa',
        ChapterDetails:ChapterDetails,
            showBuscador: true,

              //   categoriaSeleccionada: "todos",
      categorias: [],
      }
    },
    components:{

        CoreView,
        CerrarSesionDialog,
        OpenLinksTecDialog,

    },
    computed: {
      ...mapGetters(['linksStore'])
    },
  async  mounted(){

       await   this.listarVendedores();//cargar datos de vendedore

      /*   const id = this.$route.params.identificador;

    let valor = 0;

    switch (id) {
      case 'all':
        valor = 0;
        break;

      default:
        valor = id;
        break;
    }*/


const identificadorRuta = this.$route.params.identificador;

// Buscar si existe en la lista
const vendedorEncontrado = this.vendedores.find(
  v => v.identificador === identificadorRuta
);

let valor = 'all';

if (identificadorRuta === 'all') {
  valor = 'all';
} 
else if (vendedorEncontrado) {
  // ✅ Existe en la lista
  valor = identificadorRuta;
} 
else {
  // ❌ No existe → redirigir a all
  this.$router.replace({ name: 'homeTiendaAll', params: { identificador: 'all' } });
  valor = 'all';
}



/*const identificadorRuta = this.$route.params.identificador;

const vendedorValido =
  identificadorRuta === 'all' ||
  this.vendedores.some(v => v.identificador === identificadorRuta);

if (!vendedorValido) {
  this.$router.replace({ name: 'homeTiendaAll', params: { identificador: 'all' } });
}

const valor = identificadorRuta === 'all' ? 0 : identificadorRuta;
*/

    this.$emit('update-vendedor', valor);//se emite para actualizar la primera vez tambien el vendedor en la pantalla de productos

  this.vendedorSeleccionadoLocal=valor;



        this.listarCategoriasPublico(valor);

    },


    methods: {


      openLinksTec()
      {

         this.$refs.componenteHijoOpenLinksTec.openDialog();

      },



     validarRuta(){




        
      },





     onChange(val) {
      this.$emit('update-vendedor', val);

     // this.vendedorSeleccionado=val;

     this.vendedorSeleccionadoLocal=val;


     this.listarCategoriasPublico(val);


    },

      async listarVendedores() {
  try {
    const res = await vendedorService.listarVendedores();
    this.vendedores = res.data.data;

    // Validar después de cargar
    //this.validarRuta();

  } catch (error) {
    console.error(error);
  } finally {
    this.loading = false;
  }
},

     listarCategoriasPublico(vendedor) {
      //this.loading = true;

      console.log("Cambie de vendedor");
      console.log(vendedor);

      categoriaService
        .listarCategoriasPorVendedor(vendedor)
        .then((resposta) => {
          console.log(resposta.data.data);
          this.categorias = resposta.data.data;
        }).finally(() => {
        //  this.loading = false;
        });

    },

       updateBuscador(value) {
    this.$emit('update-buscador', value);
  },
      ...mapMutations(['toggleDrawer']),
      onClick (e, item) {
        e.stopPropagation()
        if (item.to || !item.href) return
        this.$vuetify.goTo(item.href)
      },
  openStore(){



     
    this.categoriaLocal = this.categorias[0].descripcion;

      this.$emit('update-categoria', 'todos');



  },

  openCerrarSesionDialog() {
    this.$refs.componenteHijo.openDialog(); // Llama al método en el componente hijo
    },
    openLinksTecDialog() {
    this.$refs.componenteHijoOpenLinksTec.openDialog(); // Llama al método en el componente hijo
    },


    }

    ,

  watch: {

     vendedorSeleccionado(newVal) {
      this.vendedorSeleccionadoLocal=newVal;
    this.listarCategoriasPublico(newVal);
  },


  '$route.params.identificador': {
    immediate: true,
    handler(newVal) {
      let valor = 0;

      if (newVal === 'all') {
        valor = 0;
      }
      
      if(newVal === 'teczoa') {
        valor = 1;
      }

       if(newVal === 'lizmar') {
        valor = 2;
      }

      // 🔥 Esto marca el radio correcto
      this.vendedorSeleccionadoLocal = valor;
    }
  }

   /*vendedorSeleccionadoLocal(newVal) {
     this.$emit('update-vendedor', newVal)

  }*/




  }
  } 
</script >

<style scoped>
.divider {
   height: 2px;
   background-color: #ccc;
}



</style>

